export function initializeTooltip(html) {
    // mock or actual tooltip
}

export function renderScheduleEventUI(data, formatDate, getStatusColor) {
    if (data.isEvent) {
        let badge_id = data.original.id;
        let badge_display = data.original.id;

        if (data.original.original_promoted_event_id) {
            badge_id = data.original.original_promoted_event_id;
            badge_display = "promoted: " + badge_id;
        }

        if (data.original.type === "AI") {
            badge_display = data.original.event_duration_hours + "h " + badge_id;
        }

        let cal_event_color = "#333333";

        if (data.original.status_colors && data.original.status_colors.length > 0) {
            cal_event_color = getStatusColor(data.original.status_colors[0]);
        }

        let stat_causes_str = "";
        
        let show_img_icon = "";
        let show_tag_icons = "";

        if (data.original.tags) {
            for (let i = 0; i < data.original.tags.length; ++i) {
                if (data.original.tags[i].toLowerCase() === "promoted") {
                     show_tag_icons += "🌟"; 
                }
            }
        }

        return '<div class="md-largevents-title" style="background:' + cal_event_color + '">' + 
               show_img_icon + show_tag_icons + 
               '<span class="badge">' + badge_display + '</span> ' + 
               data.title + 
               '</div>';
    }
}

export function renderResourceUI(resource) {
    return '<div class="events-cont">' +
           '<div class="events-name">' + resource.name + '</div>' +
           '<div class="events-title">' + (resource.title || '') + '</div>' +
           '<img class="events-img" src="' + resource.img + '"/>' +
           '</div>';
}

export function renderDayUI(day, formatDate) {
    var date = day.date;
    return '<div>' + formatDate('DDDD', date) + '</div>' +
           '<p>' + formatDate('MMM DD', date) + '</p>';
}
